import { render, staticRenderFns } from "./IframeBlock.vue?vue&type=template&id=dd6e9040&"
import script from "./IframeBlock.vue?vue&type=script&lang=js&"
export * from "./IframeBlock.vue?vue&type=script&lang=js&"
import style0 from "./IframeBlock.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports